export default __webpack_public_path__ + "static/media/nexterEstateAgencyProject.87f344ed.JPG";